export const categoryClasses = {
	"coronavirus-updates": `bg-blue-light text-blue-text`,
	"individual-and-family": `bg-blue-light text-blue-text`,
	"small-business": `bg-red-lightest text-red-text`,
	"dental-insurance": `bg-orange-lightest text-orange-text`,
	"vision-insurance": `bg-blue-text text-blue-lightest`,
	"short-term": `bg-gray-lighter`,
	"affordable-care-act": `bg-green-light text-green-text`,
	"medicare": `bg-blue-text text-white`,
	"red-inverted": 'bg-red text-white',
	"blue-inverted": 'bg-blue text-white',
	"orange-inverted": 'bg-orange text-white',
	"green-inverted": 'bg-green text-white',
	"gray-inverted": 'bg-gray text-white',
}

export const categoryAccentClass = {
	"coronavirus-updates": `bg-blue`,
	"individual-and-family": `bg-blue`,
	"small-business": `bg-red`,
	"dental-insurance": `bg-orange`,
	"vision-insurance": `bg-blue`,
	"short-term": `bg-gray`,
	"affordable-care-act": `bg-green`,
	"medicare": `bg-blue-text`
}

export const categoryTextVar = {
	"coronavirus-updates": `var(--blue-text)`,
	"individual-and-family": `var(--blue-text)`,
	"small-business": `var(--red-text)`,
	"dental-insurance": `var(--orange-text)`,
	"vision-insurance": `var(--blue-text)`,
	"short-term": `var(--gray-text)`,
	"affordable-care-act": `var(--green-text)`,
}

export const categoryAccentVar = {
	"coronavirus-updates": `var(--blue)`,
	"individual-and-family": `var(--blue)`,
	"small-business": `var(--red)`,
	"dental-insurance": `var(--orange)`,
	"vision-insurance": `var(--blue)`,
	"short-term": `var(--gray)`,
	"affordable-care-act": `var(--green)`,
}